<template>
    <v-menu :nudge-width="100">
        <v-toolbar-title slot="activator">
          <!--<v-icon>arrow_drop_down</v-icon>-->
          <!--<span>{{menuAll}}</span>-->
          <v-icon>menu</v-icon>
        </v-toolbar-title>

        <v-list>
          <v-list-tile
            @click="goHome()"
          >
            <v-list-tile-title v-text="homeNavTitle"></v-list-tile-title>
          </v-list-tile>
        </v-list>
        <v-list>
          <v-list-tile
            @click="goNews()"
          >
            <v-list-tile-title v-text="newsNavTitle"></v-list-tile-title>
          </v-list-tile>
        </v-list>
        
        <v-list>
          <v-list-tile
            @click="goTraining()"
          >
            <v-list-tile-title v-text="trainingNavTitle"></v-list-tile-title>
          </v-list-tile>
        </v-list>
        <v-list>
          <v-list-tile
            @click="goAducation()"
          >
            <v-list-tile-title v-text="aducationNavTitle"></v-list-tile-title>
          </v-list-tile>
        </v-list>
        <v-list>
          <v-list-tile
            @click="goProgram()"
          >
            <v-list-tile-title v-text="programNavTitle"></v-list-tile-title>
          </v-list-tile>
        </v-list>
        <v-list>
          <v-list-tile
            @click="goAbout()"
          >
            <v-list-tile-title v-text="aboutNavTitle"></v-list-tile-title>
          </v-list-tile>
        </v-list>
        
    </v-menu>
</template>

<script>
import { mapState } from 'vuex'

export default {
    computed: {
        ...mapState('ContactModule', [ 
                                        'homeNavTitle',
                                        'newsNavTitle',
                                        'aboutNavTitle',
                                        'trainingNavTitle',
                                        'aducationNavTitle',
                                        'programNavTitle',
                                        'menuAll',
                                        ]),
    },
    methods: {
        goHome(){
            this.$router.push({ path: '/' })
        },
        goNews(){
            this.$router.push('news')
        },
        goAbout(){
            this.$router.push('about')
        },
        goTraining(){
            this.$router.push('trraining')
        },
        goAducation(){
            this.$router.push('aducation')
        },
        goProgram(){
            this.$router.push('programm')
        },
    }
}
</script>

